var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',[_vm._v("\n      NxtForm is down for maintenance.\n      "),_c('br'),_vm._v("\n      Please try again later.\n      "),_c('br'),_c('br'),_c('button',{staticClass:"page__refresh",on:{"click":_vm.refreshPage}},[_c('span',{staticClass:"button__text"},[_vm._v(" Try again ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }